import { useParams } from "react-router";
import { useSummaryItemReport } from "@/services/backend/htz/summary/hooks/use-summary-item-report";
import { useHtzReportShowQuery } from "@/services/backend/htz/report/api/report-api";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import {
  ReportData,
  ReportDataSkeleton,
} from "@/routes/processes/[processId]/htz/summaries/[summaryId]/items/[itemId]/report/data/_components/report-data";
import { useState } from "react";

export function DataRoute() {
  const { summaryId, itemId } = useParams();
  const { reportId } = useSummaryItemReport(summaryId!, itemId!);
  const {
    data: report,
    isLoading,
    error,
  } = useHtzReportShowQuery({ id: reportId! }, { skip: !reportId });

  // The data route components save state locally (useState), based on the
  // report values. When the workOrderPositionId is updated, the server
  // will set multiple values in the report object. To reflect this change
  // in the local state, the component tree must be re-rendered. Changing
  // the key of the ReportData component will trigger a re-render.
  const [key, setKey] = useState<string | null>(null);
  if (report && report.workOrderPositionId !== key) {
    setKey(report.workOrderPositionId);
  }

  if (error) {
    return <RTKQueryErrorAlert error={error} />;
  }

  if (isLoading) {
    return <ReportDataSkeleton />;
  }

  return <ReportData report={report!} key={key} />;
}
